var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "list-item",
      class: { "tiktok-list": _vm.network === "tiktok" },
    },
    [
      _vm.network !== "tiktok"
        ? [
            _c("div", { staticClass: "legend" }, [
              _c("p", [
                _vm._v(_vm._s(_vm.$t("dash.reporting.pdf.listItem.date"))),
              ]),
              _c("p", [
                _vm._v(_vm._s(_vm.$t("dash.reporting.pdf.listItem.type"))),
              ]),
              _c("p", [
                _vm._v(
                  _vm._s(_vm.$t("dash.reporting.pdf.listItem.publication"))
                ),
              ]),
              _c("p", [
                _vm._v(_vm._s(_vm.$t("dash.reporting.pdf.listItem.print"))),
              ]),
              _c("p", [
                _vm._v(_vm._s(_vm.$t("dash.reporting.pdf.listItem.comments"))),
              ]),
              _c("p", [
                _vm._v(_vm._s(_vm.$t("dash.reporting.pdf.listItem.shares"))),
              ]),
              _c("p", [
                _vm._v(_vm._s(_vm.$t("dash.reporting.pdf.listItem.reactions"))),
              ]),
              _c("p", [
                _vm._v(
                  _vm._s(_vm.$t("dash.reporting.pdf.listItem.engagement"))
                ),
              ]),
            ]),
            _vm._l(_vm.posts, function (post) {
              return _c("div", { key: post.id, staticClass: "item" }, [
                _c("p", [_vm._v(_vm._s(_vm.getFormatDate(post.created_time)))]),
                _c("div", { staticClass: "type-content" }, [
                  _c("div", { staticClass: "badge-type-post" }, [
                    _vm._v(_vm._s(post.type == "snippet" ? "lien" : post.type)),
                  ]),
                ]),
                _c("div", { staticClass: "publication" }, [
                  _c("div", { staticClass: "picture" }, [
                    post.type && post.type == "NATIVE_DOCUMENT"
                      ? _c("i", { staticClass: "fa-regular fa-file-pdf" })
                      : post.attachment_url
                      ? _c("img", { attrs: { src: post.attachment_url } })
                      : _c("i", { staticClass: "fa-regular fa-image-slash" }),
                  ]),
                  _c("p", [_vm._v(_vm._s(post.message))]),
                ]),
                _c("p", { staticClass: "impression number" }, [
                  _vm._v(
                    _vm._s(post.post_impressions ? post.post_impressions : 0)
                  ),
                ]),
                _c("p", { staticClass: "comment number" }, [
                  _vm._v(_vm._s(post.comments_count ? post.comments_count : 0)),
                ]),
                _c("p", { staticClass: "share number" }, [
                  _vm._v(_vm._s(post.shares_count ? post.shares_count : 0)),
                ]),
                _c("p", { staticClass: "reaction number" }, [
                  _vm._v(
                    _vm._s(
                      post.post_reactions_sum
                        ? post.post_reactions_sum
                        : "like_count" in post
                        ? post.like_count
                        : ""
                    )
                  ),
                ]),
                _c("p", { staticClass: "engagement number" }, [
                  _vm._v(
                    _vm._s(
                      post.reach_engagement
                        ? post.reach_engagement.toFixed(2) + "%"
                        : ""
                    )
                  ),
                ]),
              ])
            }),
          ]
        : [
            _c("div", { staticClass: "legend tiktok-legend" }, [
              _c("p", [
                _vm._v(_vm._s(_vm.$t("dash.reporting.pdf.listItem.date"))),
              ]),
              _c("p", [
                _vm._v(
                  _vm._s(_vm.$t("dash.reporting.pdf.listItem.publication"))
                ),
              ]),
              _c("p", [
                _vm._v(_vm._s(_vm.$t("dash.reporting.pdf.listItem.type"))),
              ]),
              _c("p", [_vm._v(_vm._s(_vm.$t("dash.reporting.impression")))]),
              _c("p", [
                _vm._v(_vm._s(_vm.$t("dash.reporting.pdf.listItem.comments"))),
              ]),
              _c("p", [
                _vm._v(_vm._s(_vm.$t("dash.reporting.pdf.listItem.shares"))),
              ]),
              _c("p", [_vm._v("Likes")]),
            ]),
            _vm._l(_vm.posts, function (post) {
              return _c(
                "div",
                { key: post.id, staticClass: "item tiktok-item" },
                [
                  _c("p", [
                    _vm._v(_vm._s(_vm.getFormatDate(post.created_time))),
                  ]),
                  _c("div", { staticClass: "publication" }, [
                    _c("div", { staticClass: "picture" }, [
                      post.attachment_url
                        ? _c("img", { attrs: { src: post.attachment_url } })
                        : _c("i", { staticClass: "fa-regular fa-image-slash" }),
                    ]),
                    _c("p", [_vm._v(_vm._s(post.message))]),
                  ]),
                  _c("div", { staticClass: "type-content" }, [
                    _c("div", { staticClass: "badge-type-post" }, [
                      _vm._v(_vm._s(post.type)),
                    ]),
                  ]),
                  _c("p", { staticClass: "impression number" }, [
                    _vm._v(
                      _vm._s(
                        post.post_impressions
                          ? _vm.numberSpacing(post.post_impressions)
                          : 0
                      )
                    ),
                  ]),
                  _c("p", { staticClass: "comment number" }, [
                    _vm._v(
                      _vm._s(post.comments_count ? post.comments_count : 0)
                    ),
                  ]),
                  _c("p", { staticClass: "share number" }, [
                    _vm._v(_vm._s(post.shares_count ? post.shares_count : 0)),
                  ]),
                  _c("p", { staticClass: "like number" }, [
                    _vm._v(_vm._s(post.like_count ? post.like_count : 0)),
                  ]),
                ]
              )
            }),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }